module.exports = __webpack_public_path__ + "static/media/home-new-mobile.27571bed.mp4";